import { BluechatLoad } from './bluechat-load.model';

export class LoadManagementSearchDto {
  public loads: BluechatLoad[]                                    = [];
  public carriers: LoadManagementSearchCarrierDto[]               = [];
  public unknownCarriers: LoadManagementSearchUnknownCarrierDto[] = [];
  public regions: LoadManagementSearchRegionDto[]                 = [];

  public static fromDto(data: any): LoadManagementSearchDto {
    if (!data) {
      return null;
    }

    const searchDto = new LoadManagementSearchDto();

    searchDto.loads           = data.loads.map(l => BluechatLoad.fromDto(l));
    searchDto.carriers        = data.carriers.map(c => LoadManagementSearchCarrierDto.fromDto(c));
    searchDto.unknownCarriers = data.unknown_carriers.map(c => LoadManagementSearchUnknownCarrierDto.fromDto(c));
    searchDto.regions         = data.regions.map(r => LoadManagementSearchRegionDto.fromDto(r));

    return searchDto;
  }
}

export class LoadManagementSearchCarrierDto {
  public name: string;
  public blueyonderCarrierCode: string;
  public bluechatEnabled: boolean;
  public region: LoadManagementSearchRegionDto;

  public static fromDto(data: any): LoadManagementSearchCarrierDto {
    if (!data) {
      return null;
    }

    const carrierDto = new LoadManagementSearchCarrierDto();

    carrierDto.name                  = data.name;
    carrierDto.blueyonderCarrierCode = data.blueyonder_carrier_code;
    carrierDto.bluechatEnabled       = data.bluechat_enabled;
    carrierDto.region                = LoadManagementSearchRegionDto.fromDto(data.region);

    return carrierDto;
  }
}

export class LoadManagementSearchUnknownCarrierDto {
  public name: string;
  public blueyonderCarrierCode: string;
  public deliveryNumbers: string[];

  public static fromDto(data: any): LoadManagementSearchUnknownCarrierDto {
    if (!data) {
      return null;
    }

    const carrierDto = new LoadManagementSearchUnknownCarrierDto();

    carrierDto.name                  = data.name;
    carrierDto.blueyonderCarrierCode = data.blueyonder_carrier_code;
    carrierDto.deliveryNumbers       = data.delivery_numbers;

    return carrierDto;
  }
}

export class LoadManagementSearchRegionDto {
  public id: string;
  public name: string;

  public static fromDto(data: any): LoadManagementSearchRegionDto {
    if (!data) {
      return null;
    }

    const regionDto = new LoadManagementSearchRegionDto();

    regionDto.id   = data.id;
    regionDto.name = data.name;

    return regionDto;
  }
}
